import axiosFetch from './config';

export const getGiftCards = async () => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: '/products?input1=484&input2=484&component=GIFT_CARDS',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getPublicServices = async () => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: '/products?input1=484&input2=484&component=PUBLIC_SERVICES',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getTopUps = async () => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: '/products?input1=484&input2=484&component=TOPUPS',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getProductById = async (productId) => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: `/products/${productId}`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}